import { DRAFT_TAG, NEEDS_QA_TAG, PARKED_TAG } from '@/constants';
import { isDirectoryExperience } from '@/features/experiences/lib/directoryTags';
import type { PageExperience } from '@/features/experiences/types';

const excludedTags = [DRAFT_TAG, NEEDS_QA_TAG, PARKED_TAG];

type Result = {
  isPublished: boolean;
  isLoading: boolean;
};

export const useIsPublished = (
  experience: PageExperience | undefined
): Result => {
  const tagTexts = experience?.directoryTags.map((tag) => tag.text) ?? [];

  return {
    isPublished:
      isDirectoryExperience(experience) &&
      !excludedTags.some((tag) => tagTexts.includes(tag)),
    isLoading: false,
  };
};
